'use client';

import InlineStyle from '@/components/InlineStyle';
import GatedResourceForm from '@/components/GatedResourceForm';

/* Contact page — bespoke, replaces the old homepage-content version.
   Hero: "Contact" + supporting line.
   Body: "Namaste!" + Google Map embed of HQ + email/call cards (left)
         and HubSpot "Send us a message" form (right).
   Form ID a02e1ebe-… is the live "Contact us" form in HubSpot portal 243089516. */
import { useTranslation } from "@/hooks/useTranslation";
const CONTACT_FORM_ID = 'a02e1ebe-793e-4c8e-a5bd-831d34464549';
export default function ContactPage() {
  const {
    t
  } = useTranslation();
  return <>
      <section className="lb-static-hero">
        <div className="lb-static-hero__wrap" style={{
        textAlign: 'center'
      }}>
          <h1 className="lb-static-hero__title" style={{
          margin: '0 auto 18px'
        }}>{t("contact.tag")}</h1>
          <p className="lb-static-hero__sub" style={{
          margin: '0 auto'
        }}>
            {t("contact.connect_to_guide_your_brand_towards")}
          </p>
        </div>
      </section>

      <section style={{
      padding: '64px 24px 96px'
    }}>
        <div style={{
        maxWidth: 1200,
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 56,
        alignItems: 'start'
      }} className="lb-contact-grid">
          {/* LEFT — Namaste + map + email/call */}
          <div>
            <h2 style={{
            fontWeight: 800,
            fontSize: 'clamp(32px, 4vw, 48px)',
            letterSpacing: '-0.025em',
            color: 'var(--text-primary)',
            margin: '0 0 28px'
          }}>
              {t("contact.namaste")}
            </h2>

            {/* Google Map iframe — Locobuzz HQ Mumbai */}
            <div style={{
            borderRadius: 16,
            overflow: 'hidden',
            border: '1px solid var(--border-light)',
            boxShadow: '0 14px 30px -16px rgba(0, 152, 255, 0.2)',
            marginBottom: 24,
            aspectRatio: '16 / 10'
          }}>
              <iframe title={t("contact.locobuzz_hq")} src="https://www.google.com/maps?q=Locobuzz+202+Krishanlal+Marwah+Marg+Marol+Andheri+East+Mumbai+400072&z=16&output=embed" width="100%" height="100%" style={{
              border: 0
            }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            </div>

            <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: 16
          }} className="lb-contact-info">
              <div style={{
              padding: 20,
              background: '#fff',
              border: '1px solid var(--border-light)',
              borderRadius: 14,
              boxShadow: '0 4px 14px -8px rgba(0, 152, 255, 0.08)'
            }}>
                <div style={{
                width: 36,
                height: 36,
                borderRadius: 8,
                background: 'var(--brand-subtle)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: 12
              }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--brand)" strokeWidth="2"><path d="M3 8l9 6 9-6M3 8v10a2 2 0 002 2h14a2 2 0 002-2V8M3 8l9-5 9 5" /></svg>
                </div>
                <div style={{
                fontSize: 13,
                color: 'var(--text-muted)',
                fontWeight: 600,
                marginBottom: 4
              }}>{t("contact.email_us")}</div>
                <a href="mailto:contactus@locobuzz.com" style={{
                color: 'var(--text-primary)',
                textDecoration: 'none',
                fontSize: 14,
                fontWeight: 600
              }}>{t("contact.contactuslocobuzzcom")}</a>
              </div>

              <div style={{
              padding: 20,
              background: '#fff',
              border: '1px solid var(--border-light)',
              borderRadius: 14,
              boxShadow: '0 4px 14px -8px rgba(0, 152, 255, 0.08)'
            }}>
                <div style={{
                width: 36,
                height: 36,
                borderRadius: 8,
                background: 'var(--brand-subtle)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: 12
              }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--brand)" strokeWidth="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.13.96.37 1.9.72 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0122 16.92z" /></svg>
                </div>
                <div style={{
                fontSize: 13,
                color: 'var(--text-muted)',
                fontWeight: 600,
                marginBottom: 4
              }}>{t("contact.call_us")}</div>
                <a href="tel:+918591692683" style={{
                color: 'var(--text-primary)',
                textDecoration: 'none',
                fontSize: 14,
                fontWeight: 600
              }}>+91 8591 692 683</a>
                <div style={{
                fontSize: 12,
                color: 'var(--text-muted)',
                marginTop: 8
              }}>{t("contact.mon_fri_830_am_530_pm")}</div>
              </div>
            </div>
          </div>

          {/* RIGHT — HubSpot-embedded contact form */}
          <div style={{
          background: 'linear-gradient(180deg, #ffffff 0%, #f5f8ff 100%)',
          border: '1px solid var(--border-light)',
          borderRadius: 20,
          padding: 32,
          boxShadow: '0 18px 40px -20px rgba(0, 152, 255, 0.18)'
        }}>
            <h3 style={{
            fontWeight: 700,
            fontSize: 22,
            color: 'var(--text-primary)',
            margin: '0 0 8px'
          }}>{t("contact.send")}</h3>
            <p style={{
            fontSize: 14,
            color: 'var(--text-muted)',
            margin: '0 0 20px'
          }}>
              {t("contact.we_typically_respond_within_one_bus")}
            </p>
            <GatedResourceForm formId={CONTACT_FORM_ID} resourceType="contact-us" resourceName="Contact Us" />
            <p style={{
            fontSize: 11,
            color: 'var(--text-muted)',
            marginTop: 14
          }}>
              {t("contact.personal_data_will_be_processed_in")} <a href="/privacy-policy/" style={{
              color: 'var(--brand)'
            }}>{t("cookies.privacy")}</a>.
            </p>
          </div>
        </div>
      </section>

      <InlineStyle css={`
        @media (max-width: 880px) {
          .lb-contact-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
        }
        @media (max-width: 520px) {
          .lb-contact-info { grid-template-columns: 1fr !important; }
        }
      `} />
    </>;
}